"use strict";

export function initInScope($scope) {
    $scope.find('.js-forgot-password').on('click', function (e) {
        let href = $(this).data('href').split(/[?]/)[0];
        let $emailInput = $(this).closest('form').find('#email');
        window.location = href + '?mail=' + $emailInput.val();
    });
}
